import { render, staticRenderFns } from "./ServiceVisit.vue?vue&type=template&id=67f1c692&scoped=true"
import script from "./ServiceVisit.vue?vue&type=script&lang=ts"
export * from "./ServiceVisit.vue?vue&type=script&lang=ts"
import style0 from "./ServiceVisit.vue?vue&type=style&index=0&id=67f1c692&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f1c692",
  null
  
)

export default component.exports